import { createAction } from 'redux-actions';

import { PageConfig } from './landing-types';

export const LANDING_ACTIONS_TYPES = {
  fetchPage: {
    initiated: '[Landing] fetch page initiated',
    fulfilled: '[Landing] fetch page fulfilled',
    failed: '[Landing] fetch page failed',
  },
};

export const landingActions = {
  fetchPage: {
    initiated: createAction<string>(LANDING_ACTIONS_TYPES.fetchPage.initiated),
    fulfilled: createAction<PageConfig>(
      LANDING_ACTIONS_TYPES.fetchPage.fulfilled
    ),
    failed: createAction<string>(LANDING_ACTIONS_TYPES.fetchPage.failed),
  },
};
